import ModalViewModel from 'infra/ModalViewModel'
import Job from 'jobs/Job'
import JobProgressionStore from 'jobs/progression/JobProgressionStore'
import { action, makeObservable } from 'mobx'
import { task } from 'mobx-task'

export default class RejectDraftInReviewDialogViewModel extends ModalViewModel {
  constructor(
    private progressionStore: JobProgressionStore,
    private job: Job,
  ) {
    super()
    makeObservable(this)
  }

  @action.bound
  rejectDraft = task.resolved(async () => {
    await this.progressionStore.setDraftRejectedProgression(this.job.id)
    this.close()
  })
}
